/**
 * Gives 'true' if running in Server Side
 */
export function isServer() {
    return typeof process !== 'undefined' && !!process.pid;
}
/**
 * Gives 'true' if running in Browser
 */
export function isBrowser() {
    return typeof window !== 'undefined' && !!window.document;
}
//# sourceMappingURL=platform.js.map